import { useState, useEffect } from 'react'
import { locatariosService } from '../services/api'
import { IconBoltOff, IconSearch, IconPlugConnected } from '@tabler/icons-react'
import api from '../services/api'

const cortesService = {
  listar: () => api.get('/cortes'),
  programar: (data) => api.post('/cortes', data),
  ejecutar: (id) => api.put(`/cortes/${id}/ejecutar`),
  cancelar: (id) => api.put(`/cortes/${id}/cancelar`),
  reactivar: (id) => api.put(`/cortes/${id}/reactivar`),
}

export default function Cortes() {
  const [cortes, setCortes] = useState([])
  const [loading, setLoading] = useState(true)
  const [mostrarNuevo, setMostrarNuevo] = useState(false)
  const [sinPermisos, setSinPermisos] = useState(false)
  const [locatarios, setLocatarios] = useState([])
  const [buscarResidente, setBuscarResidente] = useState('')
  const [residentesFiltrados, setResidentesFiltrados] = useState([])
  const [residenteSeleccionado, setResidenteSeleccionado] = useState(null)
  const [form, setForm] = useState({ locatarioId: '', motivo: '', programadoAt: '' })
  const [guardando, setGuardando] = useState(false)

  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}')
  const esDirector = usuario.rol === 'director'

  useEffect(() => { cargar() }, [])

  useEffect(() => {
    locatariosService.listar({ limit: 800 }).then(r => {
      setLocatarios(r.data.data || [])
      setResidentesFiltrados(r.data.data || [])
    })
  }, [])

  useEffect(() => {
    if (!buscarResidente.trim()) {
      setResidentesFiltrados(locatarios)
    } else {
      const q = buscarResidente.toLowerCase()
      setResidentesFiltrados(locatarios.filter(l =>
        l.nombre?.toLowerCase().includes(q) ||
        l.subscriptionExternalId?.toLowerCase().includes(q) ||
        l.email?.toLowerCase().includes(q)
      ))
    }
  }, [buscarResidente, locatarios])

  const cargar = async () => {
    setLoading(true)
    try {
      const res = await cortesService.listar()
      setCortes(res.data.data || res.data || [])
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const mostrarSinPermisos = () => {
    setSinPermisos(true)
    setTimeout(() => setSinPermisos(false), 3000)
  }

  const programar = async () => {
    if (!form.locatarioId || !form.motivo || !form.programadoAt) return
    setGuardando(true)
    try {
      await cortesService.programar(form)
      setMostrarNuevo(false)
      setForm({ locatarioId: '', motivo: '', programadoAt: '' })
      setResidenteSeleccionado(null)
      setBuscarResidente('')
      cargar()
    } catch (err) { console.error(err) }
    finally { setGuardando(false) }
  }

  const ejecutar = async (id) => {
    if (!esDirector) { mostrarSinPermisos(); return }
    await cortesService.ejecutar(id)
    cargar()
  }

  const cancelar = async (id) => {
    if (!esDirector) { mostrarSinPermisos(); return }
    await cortesService.cancelar(id)
    cargar()
  }

  const reactivar = async (id) => {
    if (!esDirector) { mostrarSinPermisos(); return }
    await cortesService.reactivar(id)
    cargar()
  }

  const formatFecha = (date) => {
    if (!date) return '—'
    return new Date(date).toLocaleDateString('es-MX', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    })
  }

  const estadoColor = (estado) => {
    if (estado === 'programado') return 'badge-alta'
    if (estado === 'ejecutado') return 'badge-resuelto'
    if (estado === 'cancelado') return 'badge-media'
    if (estado === 'pendiente_reactivar') return 'badge-abierto'
    if (estado === 'reactivado') return 'badge-resuelto'
    return 'badge-media'
  }

  const estadoTexto = (estado) => {
    if (estado === 'pendiente_reactivar') return 'pago detectado — reactivar'
    return estado
  }

  const seleccionarResidente = (l) => {
    setResidenteSeleccionado(l)
    setForm({ locatarioId: l.id, motivo: '', programadoAt: '' })
    setBuscarResidente(l.subscriptionExternalId + ' — ' + l.nombre)
  }

  return (
    <div>
      {sinPermisos && (
        <div style={{ background: '#FAECE7', border: '1px solid #F5C3B0', borderRadius: 8, padding: '10px 16px', marginBottom: 12, color: '#993C1D', fontSize: 13 }}>
          No tienes permisos para realizar esta acción. Contacta al administrador.
        </div>
      )}

      <div style={{ background: '#EAF3DE', border: '1px solid #C3DDAA', borderRadius: 8, padding: '10px 16px', marginBottom: 12, color: '#3B6D11', fontSize: 12 }}>
        El sistema revisa diariamente el estado de cuenta en TOKU. Las ordenes "programado" se generan automaticamente cuando una factura lleva 30+ dias vencida. Las ordenes "pago detectado — reactivar" aparecen cuando un residente suspendido queda al corriente.
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div style={{ fontSize: 13, color: '#8A8A7A' }}>{cortes.length} órdenes de corte</div>
        <button className="btn btn-primary" onClick={() => {
          if (!esDirector) { mostrarSinPermisos(); return }
          setMostrarNuevo(true)
        }}>
          <IconBoltOff size={15} /> Programar corte
        </button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="table">
          <thead>
            <tr>
              <th>Unidad</th>
              <th>Residente</th>
              <th>Motivo</th>
              <th>Programado</th>
              <th>Ejecutado</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan={7} style={{ textAlign: 'center', color: '#8A8A7A', padding: 24 }}>Cargando...</td></tr>
            )}
            {!loading && cortes.length === 0 && (
              <tr><td colSpan={7} style={{ textAlign: 'center', color: '#8A8A7A', padding: 40 }}>
                No hay órdenes de corte registradas
              </td></tr>
            )}
            {cortes.map(c => (
              <tr key={c.id}>
                <td style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 500 }}>
                  {c.locatario?.subscriptionExternalId}
                </td>
                <td><div style={{ fontWeight: 500 }}>{c.locatario?.nombre}</div></td>
                <td style={{ fontSize: 12, color: '#5A5A50' }}>{c.motivo}</td>
                <td style={{ fontSize: 12, color: '#8A8A7A' }}>{formatFecha(c.programadoAt)}</td>
                <td style={{ fontSize: 12, color: '#8A8A7A' }}>{formatFecha(c.ejecutadoAt)}</td>
                <td><span className={'badge ' + estadoColor(c.estado)}>{estadoTexto(c.estado)}</span></td>
                <td>
                  <div style={{ display: 'flex', gap: 6 }}>
                    {c.estado === 'programado' && (
                      <>
                        <button className="btn btn-sm"
                          style={{ background: '#FAECE7', color: '#993C1D', border: 'none' }}
                          onClick={() => ejecutar(c.id)}>
                          Ejecutar
                        </button>
                        <button className="btn btn-sm" onClick={() => cancelar(c.id)}>
                          Cancelar
                        </button>
                      </>
                    )}
                    {c.estado === 'pendiente_reactivar' && (
                      <button className="btn btn-sm"
                        style={{ background: '#EAF3DE', color: '#3B6D11', border: 'none', display: 'flex', alignItems: 'center', gap: 4 }}
                        onClick={() => reactivar(c.id)}>
                        <IconPlugConnected size={13} /> Reactivar
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {mostrarNuevo && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div className="card" style={{ width: 500, padding: 28, maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 20, marginBottom: 20 }}>
              Programar orden de corte
            </div>

            <div className="form-group">
              <label className="form-label">Buscar residente</label>
              <div style={{ position: 'relative' }}>
                <IconSearch size={14} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#8A8A7A' }} />
                <input
                  className="form-input"
                  style={{ paddingLeft: 30 }}
                  placeholder="Nombre, unidad o correo..."
                  value={buscarResidente}
                  onChange={e => {
                    setBuscarResidente(e.target.value)
                    setResidenteSeleccionado(null)
                  }}
                />
              </div>
              {buscarResidente && !residenteSeleccionado && (
                <div style={{ border: '1px solid #D4C9B0', borderRadius: 8, maxHeight: 200, overflowY: 'auto', marginTop: 4, background: '#FDFAF4' }}>
                  {residentesFiltrados.slice(0, 10).map(l => (
                    <div
                      key={l.id}
                      onClick={() => seleccionarResidente(l)}
                      style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #E8E0D0', fontSize: 13 }}
                    >
                      <span style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 500 }}>
                        {l.subscriptionExternalId}
                      </span>
                      {' — '}{l.nombre}
                    </div>
                  ))}
                  {residentesFiltrados.length === 0 && (
                    <div style={{ padding: '8px 12px', color: '#8A8A7A', fontSize: 13 }}>Sin resultados</div>
                  )}
                </div>
              )}
              {residenteSeleccionado && (
                <div style={{ background: '#EAF3DE', borderRadius: 6, padding: '6px 10px', marginTop: 6, fontSize: 12, color: '#3B6D11' }}>
                  Seleccionado: {residenteSeleccionado.subscriptionExternalId} — {residenteSeleccionado.nombre}
                </div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">Motivo</label>
              <input
                className="form-input"
                placeholder="Ej: Falta de pago — 3 meses vencidos"
                value={form.motivo}
                onChange={e => setForm({ locatarioId: form.locatarioId, motivo: e.target.value, programadoAt: form.programadoAt })}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Fecha programada</label>
              <input
                className="form-input"
                type="datetime-local"
                value={form.programadoAt}
                onChange={e => setForm({ locatarioId: form.locatarioId, motivo: form.motivo, programadoAt: e.target.value })}
              />
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn" onClick={() => {
                setMostrarNuevo(false)
                setBuscarResidente('')
                setResidenteSeleccionado(null)
              }}>
                Cancelar
              </button>
              <button
                className="btn btn-primary"
                onClick={programar}
                disabled={guardando || !form.locatarioId}
              >
                {guardando ? 'Guardando...' : 'Programar corte'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
